export default __webpack_public_path__ + "static/gantserif-medium-condensed-67a7cc9ae49047f25694ed763531ef5a.woff";